import { render, staticRenderFns } from "./_progressive-profiling.vue?vue&type=template&id=453d3d76"
import script from "./_progressive-profiling.vue?vue&type=script&lang=js"
export * from "./_progressive-profiling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports